import ReactGA from "react-ga4";
import AppEnv from "./configuration/AppEnv.js";


const MEASUREMENT_ID_LOCAL = "G-T3DEXPD2F8"; // dev
const MEASUREMENT_ID_PROD = "G-ECG44K0KQ1";   // Prod

const MEASUREMENT_ID = AppEnv.isProduction ? MEASUREMENT_ID_PROD : MEASUREMENT_ID_LOCAL;

export const initGA = () => {
    ReactGA.initialize(MEASUREMENT_ID);
};

export const trackPageView = (path) => {
    ReactGA.send({ hitType: "pageview", page: path });
};
